/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  MedicalHistoryRequestDto,
  MedicalHistoryResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MedicalHistoryRequestDtoFromJSON,
    MedicalHistoryRequestDtoToJSON,
    MedicalHistoryResponseDtoFromJSON,
    MedicalHistoryResponseDtoToJSON,
} from '../models/index';

export interface GetMedicalHistoryByPatientIdRequest {
    patientId: string;
}

export interface UpdateMedicalHistoryRequest {
    medicalHistoryRequestDto: MedicalHistoryRequestDto;
}

/**
 * 
 */
export class PatientProfileApi extends runtime.BaseAPI {

    /**
     * Get patient medical history
     * Get patient medical history
     */
    async getMedicalHistoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalHistoryResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/profile/medical-history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient medical history
     * Get patient medical history
     */
    async getMedicalHistory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalHistoryResponseDto> {
        const response = await this.getMedicalHistoryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s medical history by patient ID
     */
    async getMedicalHistoryByPatientIdRaw(requestParameters: GetMedicalHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMedicalHistoryByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/profile/medical-history/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s medical history by patient ID
     */
    async getMedicalHistoryByPatientId(requestParameters: GetMedicalHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalHistoryResponseDto> {
        const response = await this.getMedicalHistoryByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update patient medical history
     */
    async updateMedicalHistoryRaw(requestParameters: UpdateMedicalHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalHistoryResponseDto>> {
        if (requestParameters['medicalHistoryRequestDto'] == null) {
            throw new runtime.RequiredError(
                'medicalHistoryRequestDto',
                'Required parameter "medicalHistoryRequestDto" was null or undefined when calling updateMedicalHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/profile/medical-history`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MedicalHistoryRequestDtoToJSON(requestParameters['medicalHistoryRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update patient medical history
     */
    async updateMedicalHistory(requestParameters: UpdateMedicalHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalHistoryResponseDto> {
        const response = await this.updateMedicalHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
